export default {
    API_ORIGIN: null,
    API_URL: null,
    tour: null,
    tourSearchParams: "",
    mapItems: [],
    flightsSequencies: [],
    flightsFiltred: [],
    GDSData: null,
    GDSParam: null,
    saveParams: null,
    resultCount: 0,
    iAgreeToReceive: true,
}
